import React, { useState, useEffect } from "react";
import { FormControl, Button, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import Select from "react-select";
import axios from "axios";
import "../assets/css/style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilterPayload,
  clearFilterPayload,
} from "../redux/actions/filterPayloadSlice";
import { getDistrictOptions, getHealthFacilityOptions } from "../services/urls";
import API from "../services/apiMiddleware";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { useLocation } from "react-router-dom";
import { setRoleInfoData } from "../redux/actions/roleInfo";

function Filter({ sendDataToParent }) {
  const [districtLists, setDistrictLists] = useState([]);
  const [healthFacilityLists, setHealthFacilityLists] = useState([]);
  const [selectDropdownValue, setSelectDropdownValue] = useState({
    district: "",
    healthFacility: "",
  });
  const [dateRange, setDateRange] = useState([null, null]);
  const [disableFlag, setDisableFlag] = useState(true);
  const [facilityFlag, setFacilityFlag] = useState(true);
  const [districtFlag, setDistrictFlag] = useState(false);
  const [downloadCSV, setDownloadCSV] = useState(false);

  const dispatch = useDispatch();
  const communityId = useSelector((state) => state.communityData.communityId);
  const location = useLocation();
  const isUserInfoPage = location.pathname === "/userinfo";
  const roleInfoData = useSelector((state) => state.roleInfoData);

  useEffect(() => {
    getDistrictLists();
  }, []);

  useEffect(() => {
    if (Object.keys(selectDropdownValue.district).length > 0) {
      getHealthFacilityLists(selectDropdownValue.district);
    }
  }, [selectDropdownValue.district]);

  // Run only when roleInfoData changes
  useEffect(() => {
    let payload = {};
    if (roleInfoData) {
      if (roleInfoData.districtValue != null) {
        setSelectDropdownValue({
          district: {
            label: roleInfoData.districtValue,
            value: roleInfoData.districtFilter,
            questionId: [roleInfoData.questionId] || null,
          },
        });
        payload = {
          ...payload,
          questionId: roleInfoData.questionId,
          districtFilter: roleInfoData.districtFilter,
          districtValue: roleInfoData.districtValue,
        };
        setDistrictFlag(true);
        setFacilityFlag(false);
      } else if (roleInfoData.healthFacilityValue != null) {
        setSelectDropdownValue({
          healthFacility: {
            label: roleInfoData.healthFacilityValue || null,
            value: roleInfoData.healthFacilityFilter || null,
            questionId: [roleInfoData.questionId] || null,
          },
        });
      }
      dispatch(setFilterPayload(payload));
      // handleApplyFilter();
    }
  }, [roleInfoData]);

  const getDistrictLists = async () => {
    const isPayload = {
      communityId,
    };

    API.post(getDistrictOptions, isPayload)
      .then(({ data }) => {
        let districtLists = data.data;
        const districtOptions = Object.keys(districtLists.optionMap);
        const districts = districtOptions.map((district) => {
          return {
            label: districtLists.optionMap[district],
            value: district,
            questionId: districtLists.questionIds,
          };
        });
        setDistrictLists(districts);
      })
      .catch((error) => {
        console.error("Error fetching district data:", error);
      });
  };

  const getHealthFacilityLists = async (param) => {
    const isPayload = {
      communityId,
      selectedOptions: [param.value],
      questionIds: param.questionId,
      languageId: 1,
    };
    API.post(getHealthFacilityOptions, isPayload)
      .then(({ data }) => {
        let healthFacility = data.data;
        const healthFacilityOptions = Object.keys(healthFacility.optionMap);
        const healthFacilities = healthFacilityOptions.map((facility) => {
          return {
            label: healthFacility.optionMap[facility],
            value: facility,
            questionId: healthFacility.questionId,
          };
        });
        setHealthFacilityLists(healthFacilities);
      })
      .catch((error) => {
        console.error("Error fetching health facility data:", error);
      });
  };

  const handleChange = (event, identifier) => {
    if (identifier == "district") {
      setFacilityFlag(false);
    }
    setSelectDropdownValue((prev) => ({
      ...prev,
      [identifier]: event,
    }));
    setDisableFlag(false);
  };

  // Update handlers to dispatch to Redux
  const handleDateRangeChange = (newValue) => {
    setDateRange(newValue);
    setDisableFlag(false);
  };

  const handleApplyFilter = () => {
    // dispatch(setDefaultSurveyCategory(selectedCatgeoryProgram));
    let payload = {};

    // if (
    //   selectedAge.value != null ||
    //   selectedGender.value != null ||
    //   selectedProgram.value != null ||
    //   selectedCatgeoryProgram.value != null
    // ) {
    //   if (selectedAge.value != null) {
    //     payload = {
    //       userRegistrationFilterData: {
    //         userRegQuestionOptionData: [
    //           ...(payload.userRegistrationFilterData
    //             ?.userRegQuestionOptionData || []),
    //           {
    //             questionIds: [selectedAge.id.toString()],
    //             optionMap: [selectedAge.value],
    //           },
    //         ],
    //       },
    //     };
    //   }

    //   if (selectedGender.value != null) {
    //     payload = {
    //       userRegistrationFilterData: {
    //         userRegQuestionOptionData: [
    //           ...(payload?.userRegistrationFilterData
    //             ?.userRegQuestionOptionData || []),
    //           {
    //             questionIds: [selectedGender.id.toString()],
    //             optionMap: [selectedGender.value],
    //           },
    //         ],
    //       },
    //     };
    //   }
    //   if (selectedProgram != null) {
    //     payload.surveyCategory = [selectedProgram.label];
    //   }
    //   if (Object.keys(selectedCatgeoryProgram).length > 0) {
    //     payload.surveyCategory = [selectedCatgeoryProgram.label];
    //   }
    // } else {
    //   payload = null;
    // }
    if (Object.keys(selectDropdownValue.district).length > 0) {
      const { questionId, value, label } = selectDropdownValue.district;
      payload = {
        ...payload,
        questionId: questionId[0],
        districtFilter: value,
        districtValue: label,
      };
    }

    if (
      selectDropdownValue?.healthFacility &&
      Object.keys(selectDropdownValue?.healthFacility).length > 0
    ) {
      const { questionId, value } = selectDropdownValue.healthFacility;
      payload = {
        ...payload,
        depQuestionId: questionId && questionId[0],
        healthFacilityFilter: value,
        districtValue: selectDropdownValue.district.label,
        healthFacilityValue: selectDropdownValue.healthFacility.label,
      };
    }

    if (dateRange[0] && dateRange[1]) {
      payload.dateFilter = {
        from: dateRange[0].format("YYYY-MM-DD") + "T00:00:00",
        to: dateRange[1].format("YYYY-MM-DD") + "T00:00:00",
      };
    }
    dispatch(setFilterPayload(payload));
  };

  const handleClearFilter = () => {
    if (districtFlag) {
      setSelectDropdownValue({
        district: {
          label: roleInfoData.districtValue,
          value: roleInfoData.districtFilter,
          questionId: [roleInfoData.questionId] || null,
        },
        healthFacility: "",
      });

      let payload = {
        questionId: selectDropdownValue.district.questionId[0],
        districtFilter: selectDropdownValue.district.value,
        districtValue: selectDropdownValue.district.label,
      };
      dispatch(setFilterPayload(payload));
    } else {
      dispatch(clearFilterPayload(null));
      setSelectDropdownValue({
        district: "",
        healthFacility: "",
      });
    }
    // setSelectDropdownValue({
    //   district: "",
    //   healthFacility: "",
    // });
    setDateRange([null, null]);
    setDisableFlag(true);
  };

  const handleExcelDownload = () => {
    sendDataToParent(true); // pass true to indicate Excel download
  };

  return (
    <div>
      <div className="filters">
        <div className="filtersection">
          {isUserInfoPage && (
            <div className="download-excel-user-info">
              <Button
                endIcon={<DownloadForOfflineIcon />}
                onClick={handleExcelDownload}
                style={{ color: "white" }}
              >
                Download Excel
              </Button>
            </div>
          )}

          <Typography>Filter By:</Typography>
          <div className="filterbtn">
            {/* {isOverViewPage ? (
              // overview page dropdown
              <FormControl fullWidth className="programform">
                <Select
                  value={selectedProgram}
                  onChange={(event) => {
                    handleInputChange(event);
                  }}
                  options={programsData}
                  placeholder={"Program"}
                  className="programselect"
                  styles={customStyles}
                  noOptionsMessage={() => "No Options Available"}
                />
              </FormControl>
            ) : (
              // category page dropdown
              <FormControl fullWidth className="programform">
                <Select
                  value={selectedCatgeoryProgram}
                  onChange={(event) => {
                    handleCategoryInputChange(event);
                  }}
                  options={programsData}
                  className="programselect"
                  styles={customStyles}
                  noOptionsMessage={() => "No Options Available"}
                />
              </FormControl>
            )}
            <FormControl fullWidth className="programform">
              <Select
                value={selectedAge}
                onChange={(event) => {
                  setDisableFlag(false);
                }}
                options={ageDataOptions}
                placeholder={"AGE RANGE"}
                className="programselect"
                // styles={customStyles}
                // isDisabled={!questionData?.length}
                noOptionsMessage={() => "No Options Available"}
              />
            </FormControl> */}

            <FormControl fullWidth className="programform">
              <Select
                value={selectDropdownValue.district}
                onChange={(e) => handleChange(e, "district")}
                options={districtLists}
                placeholder="District"
                className="programselect"
                noOptionsMessage={() => "No Options Available"}
                isDisabled={districtFlag}
              />
            </FormControl>
            <FormControl fullWidth className="programform">
              <Select
                value={selectDropdownValue.healthFacility}
                onChange={(e) => handleChange(e, "healthFacility")}
                options={healthFacilityLists}
                placeholder="Facility"
                className="programselect"
                noOptionsMessage={() => "No Options Available"}
                isDisabled={facilityFlag}
              />
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div
                className="date-picker-container"
                style={{ display: "flex", gap: "16px" }}
              >
                <FormControl fullWidth className="programform">
                  <DatePicker
                    label=""
                    placeholder="FROM"
                    value={dateRange[0]}
                    onChange={(newValue) => {
                      handleDateRangeChange([newValue, dateRange[1]]);
                    }}
                    maxDate={dateRange[1] || undefined}
                    slotProps={{
                      textField: {
                        placeholder: "From",
                        className: "daterange-input",
                        fullWidth: true,
                      },
                    }}
                  />
                </FormControl>
                <FormControl fullWidth className="programform">
                  <DatePicker
                    label=""
                    placeholder="TO"
                    value={dateRange[1]}
                    onChange={(newValue) => {
                      handleDateRangeChange([dateRange[0], newValue]);
                    }}
                    minDate={dateRange[0] || undefined}
                    slotProps={{
                      textField: {
                        placeholder: "To",
                        className: "daterange-input",
                        fullWidth: true,
                      },
                    }}
                  />
                </FormControl>
              </div>
            </LocalizationProvider>
          </div>
        </div>
        <div className="filteringbtns">
          <Button
            variant="contained"
            disabled={disableFlag}
            onClick={handleApplyFilter}
          >
            Apply
          </Button>
          <Button
            variant="contained"
            className="clearbtn"
            onClick={() => handleClearFilter()}
            disabled={disableFlag}
            // onClick={() => {
            //   setSelectDropdownValue({ Age: "", Gender: "", Program: "" });
            //   setDateRange([null, null]);
            //   dispatch(clearFilterPayload(null)); // clear the filter payload in Redux store
            //   dispatch(setGender(null));
            //   dispatch(setAgeRange(null));
            //   dispatch(setProgramFilter(null));
            // }}
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Filter;
